import { render } from "./ExplanationComponent.vue?vue&type=template&id=4df6c720&scoped=true"
import script from "./ExplanationComponent.vue?vue&type=script&lang=js"
export * from "./ExplanationComponent.vue?vue&type=script&lang=js"

import "./ExplanationComponent.vue?vue&type=style&index=0&id=4df6c720&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df6c720"]])

export default __exports__